import { useEffect, useMemo, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    t,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        date: null,
        read_flag: null,
        relevancy: null,
        text: undefined
    });

    const isFirstRender = useRef(true);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'date',
                title: 'Date',
                icon: <i className="ri-calendar-event-line" />,
                isLoading: false,
                defaultValue: tableFilters?.date,
                data: [
                    {
                        id      :   'lastWeek',
                        title   :   'Last Week'
                    },
                    {
                        id      :   'lastMonth',
                        title   :   'Last Month'
                    },
                    {
                        id      :   'lastThreeMonth',
                        title   :   'Last Three Month'
                    },
                    {
                        id      :   'lastYear',
                        title   :   'Last Year'
                    }
                ],
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'radio_list',
                name: 'read_flag',
                title: 'Read Status',
                icon: <i className="ri-checkbox-circle-fill" />,
                isLoading: false,
                defaultValue: tableFilters?.read_flag,
                data: [
                    {
                        id      :   true,
                        title   :   'Read'
                    },
                    {
                        id      :   false,
                        title   :   'Unread'
                    }
                ],
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'radio_list',
                name: 'relevancy',
                title: 'Relevancy',
                icon: (
                    <i className="ri-thumb-up-fill" />
                ),
                isLoading: false,
                defaultValue: tableFilters?.relevancy,
                data: [
                    {
                        id      :   1,
                        title   :   'Relevant'
                    },
                    {
                        id      :   0,
                        title   :   'Not Relevant'
                    }
                ],
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'search_textbox',
                name: 'text',
                title: 'Search Text',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.text,
                options: {
                    placeholder: 'Search in title and body'
                },
                formatter: (item) => {
                    return item.title
                }
            }
        ]
    }, [ tableFilters ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}

            if ('relevancy' in filters) {
                result.relevancy = filters.relevancy !== 'all' ? filters.relevancy : undefined
            }

            if ('read_flag' in filters) {
                result.read_flag = filters.read_flag !== 'all' ? filters.read_flag : undefined
            }

            if ('date' in filters) {
                result.date = filters.date !== 'all' ? filters.date : undefined
            }

            if('text' in filters && filters.text !== ''){
                result.text = filters.text;
            }
            else{
                result.text = undefined;
            }
            
            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                date: undefined,
                read_flag: undefined,
                relevancy: undefined,
                text: undefined
            })
        }
    }

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        onChange && onChange({
            event: 'filter',
            data: tableFilters
        })
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='date'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);